module.exports = __webpack_public_path__ + "ed609470171e70673a1279c6aa369623.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/soundway.jpg
 ** module id = 447
 ** module chunks = 0
 **/